import { FormSingleSelectCustomField } from 'components/pages/jobApplication/CustomElementForm/CustomFormFields/FormSingleSelectCustomField';
import React from 'react';
import clearIcon from 'assets/apply.clevry/Icon_FAQ_02.png';
import { useField, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

type menuOptionsInner = {
  label: string;
  value: number;
}[];

type UltimateDreamJobPageRowProps = {
  rowNumber: number;
  menuOptions: { roleTitle: menuOptionsInner; roleLevel: menuOptionsInner };
};

const UltimateDreamJobPageRow = ({
  rowNumber,
  menuOptions,
}: UltimateDreamJobPageRowProps) => {
  const useNumberForValue = true;
  const allowEmptyLabels = true;

  const { t } = useTranslation('Matching+Process', { i18n });

  const formik = useFormikContext<keyof string>();

  const handleClearRow = () => {
    formik.setFieldValue(`RoleTitle${rowNumber}`, undefined);
    formik.setFieldValue(`RoleLevel${rowNumber}`, undefined);
  };

  return (
    <div className="MatchingProcessPageRow">
      <FormSingleSelectCustomField
        fieldName={`RoleTitle${rowNumber}`}
        label={t('SSCandidate_Matching_Process_Job_Title')}
        options={menuOptions.roleTitle}
        useNumberForValue={useNumberForValue}
        allowEmptyLabels={true}
      />
      <FormSingleSelectCustomField
        fieldName={`RoleLevel${rowNumber}`}
        label={t('SSCandidate_Matching_Process_Role_Level')}
        options={menuOptions.roleLevel}
        useNumberForValue={useNumberForValue}
        allowEmptyLabels={true}
      />

      <div className="ClearRowButton" onClick={handleClearRow}>
        <img src={clearIcon} alt={t('SSCandidate_Matching_Process_Alt_Clear_Row')} />
      </div>
    </div>
  );
};

export default UltimateDreamJobPageRow;
